var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","height":"100"}},[_c('v-app-bar-nav-icon',{staticClass:"primary--text",on:{"click":function($event){return _vm.drawer()}}}),_c('v-container',{staticClass:"py-0 fill-height",attrs:{"fluid":""}},[(
        _vm.$vuetify.breakpoint.name == 'lg' ||
        _vm.$vuetify.breakpoint.name == 'xl' ||
        _vm.$vuetify.breakpoint.name == 'md'
      )?_c('div',{staticClass:"mr-3"},[_c('v-img',{attrs:{"src":require("@/assets/gambar/logo-new.png"),"max-width":"200"}})],1):_c('div',{staticClass:"mr-3"},[_c('v-img',{attrs:{"src":require("@/assets/gambar/logo-new.png"),"max-width":"150"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }